import React from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useAppContext } from "@/App";
import { DevForm } from "@components/Forms/Fields";
import { useSubmit } from "@components/Forms/Handlers";

export function RenderForm({
    prefix = "main",
    colLabel,
    colField,
    hideFields = [],
    bareForm,
    buttons,
    submitButtonText,
    submitMethod,
    asRow,
    submitUrl,
    afterRespOK,
    hideInputs,
    backUrl,
    apiData,
    setApiData,
}) {
    const { t } = useTranslation();
    const { apiData: appApiData, setApiData: appSetApiData } = useAppContext();
    const onFormSubmit = useSubmit({ submitUrl, submitMethod });

    apiData ||= appApiData;
    setApiData ||= appSetApiData;

    if (!(apiData?.forms_data && apiData?.forms_data[prefix])) {
        // не надо возвращать ошибок
        return;
    }

    const formFields = () => {
        return (
            <>
                {apiData.forms_data[prefix].ordered_fields &&
                    apiData.forms_data[prefix].ordered_fields.map((name, i) => {
                        return hideFields.includes(name) ? null : (
                            <DevForm.Field
                                key={`${prefix}.${apiData.forms_data[prefix].ordered_fields[i]}`}
                                prefix={prefix}
                                apiData={apiData}
                                setApiData={setApiData}
                                name={name}
                                hideInputs={hideInputs}
                                asRow={asRow}
                                colLabel={colLabel}
                                colField={colField}
                            />
                        );
                    })}
            </>
        );
    };

    if (bareForm) {
        return formFields();
    }

    return (
        <Form onSubmit={(ev) => onFormSubmit(ev, { backUrl, submitPrefixes: [prefix], onOK: afterRespOK })}>
            {formFields()}
            {buttons || (
                <DevForm.Button variant="primary" type="submit" name="action_form" value={prefix}>
                    {submitButtonText || t("Сохранить")}
                </DevForm.Button>
            )}
        </Form>
    );
}
